import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import TextField from "@mui/material/TextField";
import {connect} from "react-redux";
import store from "../../redux/store";
import {USER_CLOSE_ALERT} from "../../redux/type";
import ChromeReaderModeIcon from '@mui/icons-material/ChromeReaderMode';
import {quoteCalculation} from "../../redux/actions/modal";


class QuoteCalculation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            startDate: null,
            endDate: null,
            TrackingNumbers: ''
        }
    }
    Close = () => {
        this.setState({open: false})
    }
    Open = () => {
        this.setState({open: true})
    }
    handleSubmit = e => {
        e.preventDefault()
        const { startDate, endDate, TrackingNumbers } = this.state;

        // 将 yyyy-MM-dd 转换为 Date 对象
        const start = new Date(startDate + 'T00:00:00');
        const end = new Date(endDate + 'T00:00:00');

        // 获取 UTC 格式时间字符串
        const utcStart = start.toISOString();
        const utcEnd = end.toISOString();

        const trackNos = TrackingNumbers.split("\n").filter(item => item !== "");

        this.props.quoteCalculation(utcStart, utcEnd, trackNos)
        this.setState({open: false})
    }
    closeAlert = () => {
        store.dispatch({type: USER_CLOSE_ALERT})
    }
    render() {
        return (
            <span>
            <Button
                sx={{textTransform: 'none'}}
                startIcon={<ChromeReaderModeIcon />}
                onClick={() => {
                    this.Open();
                }}
            >
                报价计算
            </Button>
            <Dialog
                disableEscapeKeyDown
                open={this.state.open}
                onClose={() => {
                    this.Close();
                }}
            >
                <DialogTitle>报价计算</DialogTitle>
                <DialogContent>
                    <Box component="form" onSubmit={this.handleSubmit}>
                        <FormControl sx={{m: 1, minWidth: 500}}>
                            <TextField
                                id="startDate"
                                label="开始日期"
                                type="date"
                                value={this.state.startDate || ''}
                                onChange={(e) => {
                                    this.setState({startDate: e.target.value})
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </FormControl>
                        <FormControl sx={{m: 1, minWidth: 500}}>
                            <TextField
                                id="endDate"
                                label="结束日期"
                                type="date"
                                value={this.state.endDate || ''}
                                onChange={(e) => {
                                    this.setState({endDate: e.target.value})
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </FormControl>
                        <FormControl sx={{m: 1, minWidth: 500}}>
                            <TextField
                                id="outlined-multiline-flexible"
                                name="TrackingNumbers"
                                label="主单号 每行一个"
                                multiline
                                onChange={(e) => {
                                    this.setState({TrackingNumbers: e.target.value})
                                }}
                                value={this.state.TrackingNumbers}
                                maxRows={5}
                                rows={5}
                            />
                        </FormControl>
                        <DialogActions>
                            <Button
                                fullWidth
                                variant="contained"
                                sx={{mt: 3, mb: 2, ml: 45}}
                                onClick={() => {
                                    this.Close();
                                }}
                            >
                                Cancel
                            </Button>
                            <Button fullWidth type="submit" variant="contained" sx={{mt: 3, mb: 2}}>
                                Submit
                            </Button>
                        </DialogActions>
                    </Box>
                </DialogContent>
            </Dialog>
        </span>
        );
    }
}

// 更新就渲染
const mapStateToProps = (state) => ({
    isAuthenticated: state.auth.isAuthenticated,
    user: state.auth.user,
});

export default connect(mapStateToProps, {quoteCalculation})(QuoteCalculation);